import { Injectable, Output, EventEmitter } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Utils } from '../../utils';
import { environment } from 'src/environments/environment';


@Injectable({
    providedIn: 'root'
})
export class SettingsService {
    @Output() addressSelectEvent: EventEmitter<any> = new EventEmitter<any>();
    public selectedAddress:any;
    constructor(
        private http: HttpClient
    ) { }
    
    getMemberShipPlans(){
        return this.http.get<any[]>(`${environment.apiUrl}/settings/getmembershipplans`);
    }

    getCities(){
        return this.http.get<any[]>(`${environment.apiUrl}/settings/getcities`);
    }

    applyMembershipPlan(data){
        return this.http.post(`${environment.apiUrl}/settings/applymembershipplan`, data, 
        {
            headers: new HttpHeaders({
            "Content-Type": "application/json"
        })});
    }

    addSuiteCode(data){
        return this.http.post(`${environment.apiUrl}/settings/addsuitecode`, data, 
        {
            headers: new HttpHeaders({
            "Content-Type": "application/json"
        })});
    }

    updateInfo(data){
        return this.http.post(`${environment.apiUrl}/settings/updateinfo`, data, 
        {
            headers: new HttpHeaders({
            "Content-Type": "application/json"
        })});
    }

    updateEmail(data){
        return this.http.post(`${environment.apiUrl}/settings/updateemail`, data, 
        {
            headers: new HttpHeaders({
            "Content-Type": "application/json"
        })});
    }

    changePassword(data){
        return this.http.post(`${environment.apiUrl}/settings/changepassword`, data, 
        {
            headers: new HttpHeaders({
            "Content-Type": "application/json"
        })});
    }

    getAddressBook(){
        return this.http.get<any[]>(`${environment.apiUrl}/settings/getaddressbooklist`);
    }

    addNewAddress(data){
        return this.http.post(`${environment.apiUrl}/settings/addnewaddress`, data, 
        {
            headers: new HttpHeaders({
            "Content-Type": "application/json"
        })});
    }

    deleteAddressBook(id){
        return this.http.delete(`${environment.apiUrl}/settings/deleteaddressbook/${id}`,
        {
            headers: new HttpHeaders({
            "Content-Type": "application/json"
        })});
    }

    getMembersPlanPricing(){
        return this.http.get<any[]>(`${environment.apiUrl}/settings/getmembersplanpricing`);
    }

    getCityPricing(cityId){
        return this.http.get<any[]>(`${environment.apiUrl}/settings/getcitypricing/${cityId}`);
    }

    setSelectedAddress(){
        this.addressSelectEvent.emit(this.selectedAddress);
    }

    loginToOldSystem(){
        return this.http.get<any[]>(`${environment.apiUrl}/settings/logintooldsystem`);
    }

    handleSquarePayment(data){
        return this.http.post(`${environment.apiPaymentUrl}/payment/handlesquarepay`, data, 
        {
            headers: new HttpHeaders({
            "Content-Type": "application/json"
        })});
    }

    paypalBridge(orderId, token)
    {
        return this.http.get<any[]>(`${environment.apiPaymentUrl}/payment/paypalbridge?orderId=${orderId}&token=${token}`);
    }

    getPaymentOptions(){
        return this.http.get<any[]>(`${environment.apiUrl}/settings/getpaymentoptions`);
    }

    getPaymentOptionsAll(){
        return this.http.get<any[]>(`${environment.apiUrl}/settings/getpaymentoptionsall`);
    }

    confirmIntegration(){
        return this.http.post(`${environment.apiUrl}/settings/confirmintegration`, {}, 
        {
            headers: new HttpHeaders({
            "Content-Type": "application/json"
        })});
    }

    removeSuiteConnection(){
        return this.http.post(`${environment.apiUrl}/settings/removesuiteconnection`, {}, 
        {
            headers: new HttpHeaders({
            "Content-Type": "application/json"
        })});
    }
}